import { useEffect } from "react";
import Footer from "../../layout/footer";
import Header from "../../layout/header";
import Slider from "../components/slider";

function Home() {
  useEffect(() => {
    document.querySelector("body")?.setAttribute("color", "color_1");
  }, []);
  return (
    <>
	<Header />
	  <div className="page-content bg-white" id="top">
        <Slider />
      </div>
	  <Footer />
    </>
  );
}

export default Home;
